import type { AsyncHasMany } from '@ember-data/model';
import { attr } from '@ember-data/model';
import { hasMany } from '@ember-data/model';
import type ApplicationModel from './application';
import type ActionModel from './action';
import type ProductModel from './product';
import BaseApplyUserModel from './base-apply-user';

export default class UserModel extends BaseApplyUserModel {
  @attr() declare role: string;
  @attr() declare password: string;
  @attr('boolean') declare newsAgreement: boolean;
  @attr('boolean') declare termsAgreement: boolean;
  @hasMany('product') declare favorites: AsyncHasMany<ProductModel>;
  @hasMany('applications') declare applications: ApplicationModel;
  @hasMany('action') declare bookedActions: AsyncHasMany<ActionModel>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    user: UserModel;
  }
}
